module.exports = Promise.all([parcelRequire.load("4BMCH"), parcelRequire.load("cl257")]).then(() => parcelRequire('gWqmw'));